export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export const isDefined = <T>(value: T | undefined): value is T => value !== undefined;
